import { ref, computed } from "vue";

export function generateActiveElDynamicRef({
  refIdGetter,
  activeElRefIdGetterParam,
}) {
  refIdGetter = refIdGetter || ((id) => id);

  const allElRef = ref({});

  function setElRefFn(el, data) {
    allElRef.value[refIdGetter(data)] = el;
  }

  const activeElRef = computed(
    () => allElRef.value[refIdGetter(activeElRefIdGetterParam())]
  );

  return { allElRef, setElRefFn, activeElRef };
}
